import { render, staticRenderFns } from "./DragNDrop.vue?vue&type=template&id=52de6ec0&"
import script from "./DragNDrop.vue?vue&type=script&lang=js&"
export * from "./DragNDrop.vue?vue&type=script&lang=js&"
import style0 from "./DragNDrop.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DragNDrop.vue"
export default component.exports